import { Component, Input } from '@angular/core';

import { isStatusProjetadoNaoProjetado, isStatusProjetadoProjetado, isStatusProjetadoEmNegociacao, isStatusProjetadoGanho, isStatusProjetadoPerdido } from '../cliente-analise-mercado-status-projetado';

@Component({
    selector: 'sgt-cliente-analise-mercado-status-projetado-badge-pill',
    templateUrl: './cliente-analise-mercado-status-projetado-badge-pill.component.html',
    styleUrls: ['./cliente-analise-mercado-status-projetado-badge-pill.component.less']
})
export class ClienteAnaliseMercadoStatusProjetadoBadgePillComponent {
    /** Status projetado da análise de mercado */
    @Input() statusProjetado: number;
    /** ID Etapa de Negociação da Projeção */
    @Input() idEtapaNegociacaoProjecao: number = null;
    /** Nome Etapa de Negociação da Projeção */
    @Input() nomeEtapaNegociacaoProjecao: string = null;
    /** Title para exibir no badge */
    @Input() title: string = null;

    /** Verifica se é o status Não Projetado */
    isNaoProjetado(): boolean {
        return isStatusProjetadoNaoProjetado(this.statusProjetado);
    }

    /** Verifica se é o status Projetado */
    isProjetado(): boolean {
        return isStatusProjetadoProjetado(this.statusProjetado);
    }

    /** Verifica se é o status Em Negociação */
    isEmNegociacao(): boolean {
        return isStatusProjetadoEmNegociacao(this.statusProjetado);
    }

    /** Verifica se é o status Ganho */
    isGanho(): boolean {
        return isStatusProjetadoGanho(this.statusProjetado);
    }

    /** Verifica se é o status Perdido */
    isPerdido(): boolean {
        return isStatusProjetadoPerdido(this.statusProjetado);
    }
}
